import { LAYER_ASSET_HEIGHT } from '~/constant'
import { DRAGNDROP_TYPE } from '~/enums'

export const getSourceItemSourceOffset = (
  clientOffset, dragItem, detachedMode, isMultipleSourceMediaFiles
) => {
  const dragItemXOffset = isMultipleSourceMediaFiles
    || !detachedMode
    || dragItem.type !== DRAGNDROP_TYPE.TRANSITION_ITEM
    ? 0
    : 0.5 * LAYER_ASSET_HEIGHT * 1.625
  return {
    x: clientOffset.x - dragItemXOffset,
    y: clientOffset.y - 0.5 * LAYER_ASSET_HEIGHT,
    xOffset: dragItemXOffset,
  }
}
